import { render, staticRenderFns } from "./program_select_box.vue?vue&type=template&id=23c41787"
import script from "./program_select_box.vue?vue&type=script&lang=js"
export * from "./program_select_box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports